module.exports = __webpack_public_path__ + "img/download-apple-store.2bd8cd71.svg";